<div class="account-deletion-container">
  <div class="logo">
    <svg-icon src="/assets/icons/info-circle.svg" class="white-logo"></svg-icon>
  </div>
  <h1>Account Deletion Requested</h1>
  <h2>{{ dataStoreService.user?.email }}</h2>
  <p class="description">Check your email for instructions on how to complete the account deletion process.</p>
</div>
